
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DragItem',
  components: {},
  props: {
    data: {
      type: [Object, Array, String, Number],
    },
    disabled: {
      type: Boolean,
    },
    indicatorInvisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ondragstart(e: DragEvent) {
      // console.log('dragstart', e, this.data);
      e.dataTransfer?.setData('dnddata', JSON.stringify(this.data));
    },
  },
});
